import React, { useState } from 'react';
import { obtenerMaterialesAviso } from '../servicios/api';

const MaterialesAvisoResumen = ({ avisoId, precioCobrado = 0 }) => {
  const [materiales, setMateriales] = useState([]);
  const [totalVenta, setTotalVenta] = useState(0);
  const [totalCoste, setTotalCoste] = useState(0);
  const [costesPendientes, setCostesPendientes] = useState(0);
  const [cargando, setCargando] = useState(false);
  const [cargado, setCargado] = useState(false);
  const [error, setError] = useState('');

  const cargar = async () => {
    if (cargado || cargando || !avisoId) return;
    setCargando(true);
    setError('');
    try {
      const respuesta = await obtenerMaterialesAviso(avisoId);
      if (!respuesta.exito) throw new Error(respuesta.mensaje || 'No se pudieron cargar las piezas.');
      setMateriales(respuesta.materiales || []);
      setTotalVenta(Number(respuesta.venta_piezas || 0));
      setTotalCoste(Number(respuesta.gasto_piezas || 0));
      setCostesPendientes(Number(respuesta.repuestos_sin_coste || 0));
      setCargado(true);
    } catch (loadError) {
      setError(loadError.response?.data?.mensaje || loadError.message || 'No se pudieron cargar las piezas.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <details onToggle={(event) => event.currentTarget.open && cargar()} className="mt-2 text-xs">
      <summary className="cursor-pointer text-cyan-300 hover:text-cyan-200">
        Ver repuestos {cargado ? `(${materiales.length}) · venta ${totalVenta.toFixed(2)} €` : ''}
      </summary>
      <div className="mt-2 rounded border border-slate-700 bg-slate-900/70 p-3">
        {cargando && <p className="text-slate-400">Cargando materiales...</p>}
        {error && <p role="alert" className="text-red-300">{error}</p>}
        {cargado && materiales.length === 0 && <p className="text-slate-400">No hay repuestos registrados.</p>}
        {materiales.length > 0 && (
          <ul className="space-y-1 text-slate-300">
            {materiales.map((material) => (
              <li key={material.id} className="flex flex-wrap justify-between gap-x-4">
                <span>{material.concepto} × {material.cantidad}{material.tipo === null ? ' · sin clasificar' : ''}</span>
                <span>Venta: {(Number(material.precio_venta) * Number(material.cantidad)).toFixed(2)} € · Coste: {material.precio_coste === null ? 'pendiente' : `${(Number(material.precio_coste) * Number(material.cantidad)).toFixed(2)} €`}</span>
              </li>
            ))}
            <li className="flex justify-between border-t border-slate-700 pt-1 font-semibold text-white">
              <span>Margen de repuestos</span><span>{(totalVenta - totalCoste).toFixed(2)} €</span>
            </li>
          </ul>
        )}
        {costesPendientes > 0 && <p className="mt-2 text-amber-300">Coste pendiente en {costesPendientes} repuesto(s).</p>}
        {cargado && (
          <div className="mt-2 space-y-1 border-t border-slate-700 pt-2 text-slate-200">
            <p className="flex justify-between gap-3"><span>Ingreso reparación / mano de obra</span><span>{Number(precioCobrado || 0).toFixed(2)} €</span></p>
            <p className="flex justify-between gap-3"><span>Ingresos totales</span><span>{(Number(precioCobrado || 0) + totalVenta).toFixed(2)} €</span></p>
            <p className="flex justify-between gap-3 font-semibold"><span>Beneficio neto registrado</span><span>{(Number(precioCobrado || 0) + totalVenta - totalCoste).toFixed(2)} €</span></p>
          </div>
        )}
      </div>
    </details>
  );
};

export default MaterialesAvisoResumen;
